module.exports = __webpack_public_path__ + "static/media/category7.06a07e76.jpg";